import * as yup from 'yup';

const ResetPasswordFormValidation = yup.object().shape({
  verificationCode: yup.string().trim().required('Verification code is a required field'),
  name: yup.string().trim().email().required('Email is a required field'),
  newPassword: yup.string()
    .required('Please enter the new password')
    .min(8, 'New password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&^_\-+{}[\];:'"<>,.?\\/])[A-Za-z\d@$!%*#?&^_\-+{}[\];:'"<>,.?\\/]{8,}$/g,
      'Your password does not meet our password rules. Use at least 8 characters, 1 uppercase, 1 lowercase, and 1 number',
    ),
  confirmPassword: yup.string().trim().oneOf([yup.ref('newPassword'), null], 'Passwords must match'),
});
export default ResetPasswordFormValidation;
